import React, { useEffect, useState } from 'react';
import { FaArrowRight, FaArrowLeft, FaRegEdit } from 'react-icons/fa';
import { HiDotsHorizontal } from 'react-icons/hi';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2';
import { MdDeleteOutline, MdArrowDropDownCircle } from 'react-icons/md';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { BsFillFolderSymlinkFill, BsQrCode } from 'react-icons/bs';
import { RiFeedbackFill } from 'react-icons/ri';

import {
  GetOneProcedure,
  LoadProcedureOnRequest,
  LoadProcedures,
  LoadProceduresRequest,
  LoadProceduresReque,
  ProcedureDeleteSuccess,
  LoadProceduresRequestEnd,
  SetPreviousRoute,
  SetProcPage,
} from '../../Redux/ProcedureReducer';
import { folderDeleteSuccess, loadFolders } from '../../Redux/FolderSlice';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { useNavigate } from 'react-router-dom';
import EditProcedureModal from '../Modal/EditProcedureModal';
import toast from 'react-hot-toast';
import DeleteModal from '../Modal/DeleteModal';
import Loader from '../Butten/Loader';
import RenameFolderModal from '../Modal/RenameFolderModal';
import MoveFolderModal from '../Modal/FoldersModal';
import MoveProcedureModal from '../Modal/MoveProcedureModal';
import FeedbackModal from '../Modal/FeedbackModal';
import ApiHandler from '../../ApiHandler';
import CopyProcedureModal from '../Modal/CopyProcedureModal';

const ProcedureTable = ({ filtered, user, params, setIsSearch, isSearch , setSearchText, searchText }) => {
  const [selectedProcedureIndex, setSelectedProcedureIndex] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [moveFolderModal, setMoveFolderModal] = useState(false);
  const [moveProcedureModal, setMoveProcedureModal] = useState(false);
  const [copyProcedureModal, setCopyProcedureModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [folderHover, setFolderHover] = useState(null);
  const [folder, setFolder] = useState(null);
  const [procedures, setProcedures] = useState(null);

  const { folders, previousRoute } = useSelector(
    state => ({
      folders: state.Folder.folders.filter(f => f.parent === params?.id),
      previousRoute: state.Procedure.previousRoute,
    }),
    shallowEqual
  );
  const [foldersArr, setFoldersArr] = useState([]);

  // useEffect(() => {
  //   if (!user?.role?.includes("admin")) {
  //     getProcedureByUserId(user?._id);
  //   }
  // }, []);

  const handleToggle = index => {
    setSelectedProcedureIndex(index === selectedProcedureIndex ? null : index);
  };

  const onEditProcedureModel = id => {
    navigate(`/update-procedure/${id}`);
    dispatch(GetOneProcedure(id));
  };

  const { isLoading, procPage } = useSelector(
    state => ({
      isLoading: state.Procedure.isLoading,
      procPage: state.Procedure.procPage,
    }),
    shallowEqual
  );
  const onGetProcedureByFolder = async (id, folder) => {
    try {
      setIsSearch(false);
      setSearchText('');
      dispatch(SetProcPage(1));
      dispatch(LoadProceduresRequest());
      localStorage.setItem('folderId', JSON.stringify(id));
      localStorage.removeItem('step');

      const { status, data } = await api.get(
        `/procedure/getProcedureByFolderId?id=${id}`
      );
      const currentPath = window.location.pathname;
      if (previousRoute[previousRoute.length - 1] !== currentPath) {
        const route = [...previousRoute, currentPath];
        dispatch(SetPreviousRoute(route));
      }
      const fetchedProc = data?.procedures[0]?.procedures || [];
      if (user?.role?.includes('admin')) {
        if (status === 200) {
          dispatch(LoadProcedureOnRequest(fetchedProc));
          dispatch(LoadProceduresRequestEnd());
          navigate(`/procedures/${id}`);
        }
      } else {
        const usersProc = await getProcedureByUserId(user?._id);
        const similarObjects = fetchedProc.filter(fetched =>
          usersProc.some(user => user._id === fetched._id)
        );
        dispatch(LoadProcedureOnRequest(similarObjects));
        dispatch(LoadProceduresRequestEnd());
        navigate(`/procedures/${id}`);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const getProcedureByUserId = async id => {
    try {
      const { status, data } = await api.get(
        `/procedure/proceduregetbyuser/${id}`
      );
      if (status === 200) {
        dispatch(LoadProcedureOnRequest(data?.procedures || []));
        return data?.procedures || [];
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteFolderModal, setShowDeleteFolderModal] = useState(false);
  const [selected, setSelected] = useState('');

  const confirmDeleteModal = async id => {
    setSelected(id);
    setShowDeleteModal(true);
    setSelectedProcedureIndex(null);
  };

  const confirmDelete = async () => {
    handleDelete(selected);
  };

  const confirmDeleteFolder = async () => {
    onDeleteFolder(folder?._id);
  };

  const onDeleteFolder = async _id => {
    try {
      const { status } = await api.get(`/folder/deletefolder/${_id}`);
      if (status === 201) {
        dispatch(folderDeleteSuccess(_id));
        const newArr = folders.filter(item => item?._id !== _id);
        setFoldersArr(newArr);
        toast.success('Folder deleted successfully');
        ApiHandler.getFolders();
      }
    } catch (error) {
      toast.error('Error while deleting folder');
    }
  };

  const handleDelete = async _id => {
    const folderId = JSON.parse(localStorage.getItem('folderId'));
    try {
      const { status } = await api.get(`/procedure/delete-procedure/${_id}`);
      if (status === 200) {
        dispatch(ProcedureDeleteSuccess(_id));
        onGetProcedureByFolder(folderId);
        setSelectedProcedureIndex(null);
        toast.success('Procedure deleted successfully');
      }
    } catch (error) {
      toast.error('Error while deleting procedure');
    }
  };

  const downloadHandle = async url => {
    window.open(url);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15; // Number of items per page

  const totalPages = Math.ceil(filtered?.length / itemsPerPage);
  useEffect(() => {
    setCurrentPage(procPage);
  }, []);

  useEffect(() => {
    setCurrentPage(procPage);
  }, [procPage]);

  // Get items for the current page
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Handle next and previous page
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
      dispatch(SetProcPage(currentPage + 1));
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
      dispatch(SetProcPage(currentPage - 1));
    }
  };
  return (
    <>
      {isLoading ? (
        <Loader></Loader>
      ) : (
        <div className="h-max-[30vh] w-full flex flex-wrap gap-2">
          {!isSearch &&
            folders?.map((folder, index) => (
              <div
                key={index}
                onClick={() => onGetProcedureByFolder(folder?._id, folder)}
                className="relative h-[70px] flex justify-center items-center rounded-md gap-2 border border-black cursor-pointer px-2"
              >
                <BsFillFolderSymlinkFill />
                <span>{folder?.name}</span>
                {user.role?.includes('admin') && (
                  <div
                    onMouseEnter={() => setFolderHover(index)}
                    onMouseLeave={() => setFolderHover(null)}
                  >
                    <HiDotsHorizontal className="cursor-pointer absolute top-2 right-2 text-red-500 hover:text-red-700 pb-0" />
                    {folderHover === index && (
                      <div
                        className="absolute bg-gray-200 border border-gray-300 p-2 rounded-xl z-50 min-w-[150px] shadow-lg top-2"
                        onClick={e => e.stopPropagation()} // Prevents the click event from propagating
                      >
                        {user.role?.includes('admin') && (
                          <div
                            onClick={e => {
                              e.stopPropagation();
                              setShowFolderModal(true);
                              setFolder(folder);
                            }}
                            className="flex items-center gap-5 cursor-pointer"
                          >
                            <FaRegEdit size={12} />
                            <p>Rename</p>
                          </div>
                        )}

                        <div
                          className="flex items-center gap-5 cursor-pointer"
                          onClick={e => {
                            e.stopPropagation(); // Prevents propagation to parent
                            setFolder(folder);
                            setShowDeleteFolderModal(true);
                          }}
                        >
                          <MdDeleteOutline size={15} />
                          <p>Delete</p>
                        </div>

                        <div
                          className="flex items-center gap-5 cursor-pointer"
                          onClick={e => {
                            e.stopPropagation();
                            setMoveFolderModal(true);
                            setFolder(folder);
                          }} // Add this to prevent propagation
                        >
                          <MdArrowDropDownCircle size={15} />
                          <p>Move to</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
        </div>
      )}

      {((Object.keys(params).length !== 0 && !isLoading) || isSearch) && (
        <div className="w-full mt-2 bg-white border border-gray-300 rounded-2xl overflow-hidden relative">
          <table className="w-full px-10">
            <thead className="bg-gray-200 h-12 text-left">
              <tr>
                <th className="ps-5">S. NO.</th>
                <th>Procedure Name</th>
                <th>Date Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="text-left">
              {paginatedData?.map((procedure, index) => (
                <tr key={index} className="h-[6vh] border-b">
                  <td className="ps-5 max-w-[10px]">{index + 1}</td>
                  <td className="max-w-[150px] break-words pe-5">
                    <div className="flex flex-col">
                      <span>{procedure?.name}</span>
                      {procedure?.folderId?.name && searchText !== '' && (
                        <div className='cursor-pointer' onClick={() => {
                          onGetProcedureByFolder(procedure?.folderId?._id, procedure?.folderId)
                        }} style={{display: 'flex', alignItems: 'center', gap: '5px' , flexDirection: 'row'}}>
                        <BsFillFolderSymlinkFill />
                        <a className="text-xs text-gray-500 cursor-pointer" 
                        >{procedure.folderId.name}</a>
                        </div>
                      )}
                    </div>
                  </td>
                  <td>{new Date(procedure.createdAt).toDateString()}</td>
                  <td className="relative">
                    <div
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <HiDotsHorizontal size={30} className="cursor-pointer" />
                      {hoveredIndex === index && (
                        <div className="absolute bg-gray-200 border border-gray-300 p-2 rounded-xl z-50 min-w-[150px] shadow-lg top-[-10px]">
                          {user.role?.includes('admin') && (
                            <div
                              onClick={() =>
                                onEditProcedureModel(procedure?._id ? procedure?._id : procedure.id)
                              }
                              className="flex items-center gap-5 cursor-pointer"
                            >
                              <FaRegEdit size={12} />
                              <p>Edit</p>
                            </div>
                          )}
                          <div
                            onClick={() => {
                              const route = [
                                ...previousRoute,
                                window.location.pathname,
                              ];
                              dispatch(SetPreviousRoute(route));
                              navigate(`/procedure-preview/${procedure._id}`);
                              dispatch(GetOneProcedure(procedure._id));
                            }}
                            className="flex items-center gap-5 cursor-pointer"
                          >
                            <HiOutlineDocumentDuplicate size={15} />
                            <p>Preview</p>
                          </div>
                          {user.role?.includes('admin') && (
                            <div>
                              <div
                                onClick={e => {
                                  e.stopPropagation();
                                  setMoveProcedureModal(true);
                                  setProcedures(procedure);
                                }}
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <MdArrowDropDownCircle size={15} />
                                <p>Move to</p>
                              </div>
                              <div
                                onClick={e => {
                                  e.stopPropagation();
                                  setCopyProcedureModal(true);
                                  setProcedures(procedure);
                                }}
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <MdArrowDropDownCircle size={15} />
                                <p>Copy to</p>
                              </div>
                              <div
                                onClick={e => {
                                  e.stopPropagation();
                                  setFeedbackModal(true);
                                  setProcedures(procedure);
                                }}
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <RiFeedbackFill size={15} />
                                <p>Feedback</p>
                              </div>
                              <div
                                onClick={() =>
                                  confirmDeleteModal(procedure._id)
                                }
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <MdDeleteOutline size={15} />
                                <p>Delete</p>
                              </div>
                            </div>
                          )}
                          {procedure?.url && (
                            <div
                              onClick={() => downloadHandle(procedure.url)}
                              className="flex items-center gap-5 cursor-pointer"
                            >
                              <BsQrCode size={15} />
                              <p>QR Code</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="my-5 flex justify-between items-center px-16 py-4">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className={`flex items-center space-x-3 ${
                currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              <FaArrowLeft />
              <span>Prev</span>
            </button>
            <span className="font-semibold">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`flex items-center space-x-3 ${
                currentPage === totalPages
                  ? 'opacity-50 cursor-not-allowed'
                  : ''
              }`}
            >
              <span>Next</span>
              <FaArrowRight />
            </button>
          </div>
          <EditProcedureModal
            showModal={showModal}
            onClose={() => setShowModal(false)}
          />
        </div>
      )}

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        onConfirm={confirmDelete}
      />
      <DeleteModal
        showModal={showDeleteFolderModal}
        setShowModal={setShowDeleteFolderModal}
        onConfirm={confirmDeleteFolder}
      />
      <RenameFolderModal
        showModal={showFolderModal}
        setShowModal={setShowFolderModal}
        folder={folder}
      />
      <MoveFolderModal
        showModal={moveFolderModal}
        setShowModal={setMoveFolderModal}
        folder={folder}
      />
      <MoveProcedureModal
        showModal={moveProcedureModal}
        setShowModal={setMoveProcedureModal}
        procedure={procedures}
        getData={onGetProcedureByFolder}
      />
      <CopyProcedureModal
        showModal={copyProcedureModal}
        setShowModal={setCopyProcedureModal}
        procedure={procedures}
        getData={onGetProcedureByFolder}
      />
      <FeedbackModal
        showModal={feedbackModal}
        setShowModal={setFeedbackModal}
        procedure={procedures}
      />
    </>
  );
};

export default ProcedureTable;
